import { recursivePropTypeCheck } from '../../../utils/proptypeTools';

const FormInputTypes = {
  TEXT_INPUT: {
    TEXT: 'text',
    COLOR: 'color',
    TIME: 'time',
    EMAIL: 'email',
    NUMBER: 'number',
    PASSWORD: 'password',
    URL: 'url',
    URLPREVIEW:'urlpreview',
    OBJECT:'object',
    TEXT_COMMA:'comma',
    INPUT_TIME:'input_time',
    LINK:'input_link'
  },
  CELL_DATE: 'cell_date',
  COLOR_PICKER: 'color_picker',
  COUNTRY_FLAG: 'country_flag',
  TEXT: 'show_text',
  TEXT_TAG: 'text_tag',
  TEXT_SCROLL: 'show_text_scroll',
  TEXT_EDITOR: 'text_editor',
  SELECT: 'select',
  CHECKBOX: 'checkbox',
  DATE: 'date',
  DATE_TIME: 'datetime-local',
  TIME:'time',
  RADIO: 'radio',
  TABLE: 'table',
  UPLOAD_ASYNC: 'upload-async',
  MULTIPLE_UPLOAD_ASYNC: 'multiple-upload-async',
  DOWNLOADABLE: 'downloadable',
  BACKGROUND: 'background',
  STATUS: 'status',
  OTHER_RESOURCE: 'other-resource',
  RELATIONSHIP: 'relationship',
  RELATIONSHIPFILTER:'relationshipFilter',
  AUDIO: 'audio',
  TIMESTAMP: 'timestamp',
  TIMESTAMPMS:'timestampms',
  TEXT_OR_RELATIONSHIP: 'text_or_relationship',
  BUTTON: 'button',
  LINK: 'link',
  LINKFRAME:'linkFrame',
  WEBSOCKET_LOG: 'websocket_log',
  LOG:'log',
  POSTER_MATRIX: 'poster_matrix',
  CANVAS:'canvas',
  MORE: 'more',
  JSON_COMPONENT:'json_component',
  TEXT_STEP:'text_step',
  SEPARATOR:'separator',
  PLAYERICONS:'player_icons',
  POPUPTABLE:'popup_table',
  BUTTON_POPUP:'button_popup',
  BUTTON_FORM:'button_form',
  GRID_BUTTONS:'grid_buttons',
  TABLE2:'table2',
  TABLECOMPONENT:'table_component',
  ARRAY:'array',
  CAMERAS_PRESENTATION:'cameras_presentation',
  YAML:'yaml',
  JSON:'json',
  TAG:'Tag',
  TAGS_PREVIEW:'TagsPreview',
  INTERACTABLEGRAPHICSELECTOR:'InteractableGraphicSelector',
  STATIC_TEXT:'static_text',
  SPACES_MAP:'spaces_tree',
  AUDIT_CHANGES:'audit_change',
  DATE_PICKER_PARTIAL: 'date_picker_partial',
  ICON_CHECKBOX:'icon_checkbox',
};

// eslint-disable-next-line max-len
export const FormInputTypeCheck = (props, propName, componentName) => (recursivePropTypeCheck(props, propName, FormInputTypes)
  ? null : new Error(
    `Invalid prop ${propName} supplied to ${componentName}. Validation failed.`,
  ));

export default FormInputTypes;
